import { ShippingOptions } from '@cencosud-cencommerce/paris-uikit';

import { useAppSelector } from '@/Application/Hooks/Redux';
import { selectBuyNowCartData } from '@/Application/Selectors/buyNow/useBuyNowCart';
import { ProductItem } from '@/Pages/BuyNowPage/PaymentAndShipping/partials/ProductList/ProductItem';
import { selectBuyNowShippingGroupingData } from '@/sections/shippingMethods/hooks/useBuyNowShippingGrouping';
import { deliveryItemToDeliveryProduct } from '@/sections/shippingMethods/mappers/shippingMethodMapper';

export const ProductList = () => {
  const cart = useAppSelector(selectBuyNowCartData);
  const shippingGrouping = useAppSelector(selectBuyNowShippingGroupingData);
  const deliveryGroups = shippingGrouping?.deliveryGroups || [];

  if (!cart) {
    return (
      <section
        data-testid="product-item-list"
        className="co-flex co-flex-col co-gap-2 co-w-full"
      ></section>
    );
  }

  const productList =
    deliveryGroups
      ?.map((group) =>
        group?.items?.map((item) => deliveryItemToDeliveryProduct(item, cart))
      )
      .flat() || [];
  const product = productList?.[0];
  const productServices = product?.services || [];

  return (
    <section
      data-testid="product-item-list"
      className="co-flex co-flex-col co-gap-2 co-w-full"
    >
      <ProductItem product={product} />

      {productServices?.length > 0 && (
        <aside className="co-flex co-p-3 co-gap-[10px] co-pt-0 co-flex-row co-h-fit co-overflow-x-auto co-w-full tablet_w:co-flex-wrap tablet_w:co-p-6 tablet_w:co-pt-0">
          <ShippingOptions label="1A G Extendida" variant="garantia" />
          <ShippingOptions label="Armado" variant="armado" />
          <ShippingOptions label="RETIRO Y RECICLAJE" variant="reciclaje" />
        </aside>
      )}
    </section>
  );
};

ProductList.displayName = 'ProductList';

export default ProductList;
